import instance from '@/api/axiosInstance';
import { WomBasketItemsListResponse } from './womBasketItems.types';
import { API_BASE_URL } from '..';
import { getUserFromLocalStorage } from '@/utils/user';
import OAuth from '@/core/libs/OAuth/OAuth.class';

const CONTROLLER = `${API_BASE_URL}/basket-item`;

type CredentialTokens = { access_token?: string };

export default {
  async listItems(workOrderComplementId?: number) {
    const { accessToken } = getUserFromLocalStorage();
    const womTokenJson = OAuth.getCredentialTokens<CredentialTokens>('WOM');
    const womToken = womTokenJson?.access_token;

    const response = await instance.get<
      WomBasketItemsListResponse,
      WomBasketItemsListResponse
    >(`${CONTROLLER}/${workOrderComplementId}`, {
      headers: {
        'WOM-TOKEN': `Bearer ${womToken}`,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    return response;
  },
};
